import React from 'react'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'

import Home from './routes/Home'
import RecipeDetails from './routes/RecipeDetails'
import PantryDetails from './routes/PantryDetails'
import GroceryList from './routes/GroceryList'
import Signup from './routes/Signup'
import Cart from './routes/Cart'
import Analytics from './routes/Analytics'
import SideBar from './components/SideBar'

import './App.css'

function App() {
  return (
    <Router>
      <div className="Container">
        <div className="App">
          <Redirect to="/signup"/>
          <Route path="/home" component={Home}/>
          <Route path="/recipedetails" component={RecipeDetails}/>
          <Route path="/pantrydetails" component={PantryDetails}/>
          <Route path="/grocerylist" component={GroceryList}/>
          <Route path="/signup" component={Signup}/>
          <Route path="/cart" component={Cart}/>
          <Route path="/analytics" component={Analytics}/>
          <Route path="/sidebar" component={SideBar}/>
        </div>
      </div>
    </Router>
  )
}

export default App